import './crm.less';
import React from 'react';

import ProtectedLayout from '../../common/protected-layout';
import {inject, observer} from 'mobx-react';
import {NavLink, Redirect, Route, Switch} from 'react-router-dom';
import {Calls} from './call/calls';
import {Sms} from './sms/sms';
import {Leads} from './lead/leads';
import {Badge} from 'antd';

@inject("loginStore")
@inject("crmStore")
@observer
export class Crm extends React.Component {

  render() {

    const unreadCount = this.props.crmStore.totalUnreadAll;
    const unreadBadgeLeft = -50 + (unreadCount < 10 ? 10 : 0);

    return (
      <ProtectedLayout
        loginStore={this.props.loginStore}
        right={''}
        onLogout={this.props.loginStore.logout}
        className="crm-page">

        <div className="crm-tabs">
          <NavLink to={'/crm/calls'} className="crm-tab">Звонки</NavLink>
          <NavLink to={'/crm/leads'} className="crm-tab">Заявки</NavLink>
          <Badge overflowCount={999} count={unreadCount} style={{ position: 'absolute', left: unreadBadgeLeft, top: -8, right: 'inherit' }}/>
          <NavLink to={'/crm/sms'} className="crm-tab">Смс</NavLink>
        </div>

        <div className="crm-content">
          <Switch>
            <Route path="/crm/calls" component={Calls}/>
            <Route path="/crm/leads" component={Leads} />
            <Route path="/crm/sms" component={Sms} />

            <Redirect to={'/crm/calls'}></Redirect>
          </Switch>
        </div>
      </ProtectedLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/crm/crm.js